<template>
  <div id="AllFooter">
    <!-- 简介 -->
    <div class="intro">
      <!-- 内容 -->
      <div class="intro_content">
        <!-- 信息展示 -->
        <div class="intro_info">
          <div class="infoList">
            <img class="infoImg" src="@/assets/imgTwo/site.png" alt="">
            <div class="info_txt">上海市金山区亭林镇松前路4180号</div>
          </div>
           <div class="infoList">
            <img class="infoImg" src="@/assets/imgTwo/phone.png" alt="">
            <div class="info_txt">盛先生  18817877772</div>
          </div>
           <div class="infoList">
            <img class="infoImg" src="@/assets/imgTwo/email.png" alt="">
            <div class="info_txt">sweetai@163.com</div>
          </div>
        </div>

        <div class="QRcdoe">
          <div class="weixin">
            <img src="@/assets/img_home/wx.png" alt="" />
            <p>微信视频号</p>
          </div>
          <div class="douyin">
            <img src="@/assets/img_home/dy.png" alt="" />
            <p>抖音视频号</p>
          </div>
          <div class="kefu">
            <img src="@/assets/img_home/gzh.png" alt="" />
            <p>人工客服</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 备案 -->
    <!-- <a class="project_Rt_icp_" @click="handle"
      >ICP备案/许可证号：沪ICP备2021006526号-1</a
    > -->
  </div>
</template>

<script>
import { defineComponent, ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { GetDeviceSeries } from "@/api/api";

export default defineComponent({
  name: "AllFooter",
  setup() {
    const route = useRoute();
    const router = useRouter();
    onMounted(() => {
    
    });

    // 公司介绍
    function toAboutUs() {
      router.push({ path: "/AboutUs" });
    }

    // 核心优势
    function toCoreAdvantage() {
      router.push({ path: "/CoreAdvantage" });
    }

    // 人才招聘
    function toJob() {
      router.push({ path: "/jobfair" });
    }

    // 联系我们
    function toContactUs() {
      router.push({ path: "/ContactUs" });
    }

    // 视频中心
    function toVideoCenter() {
      router.push({ path: "/VideoCenter" });
    }

    // 资讯中心
    function toMovie() {
      router.push({ path: "/MediaCenter" });
    }
    return {
      toAboutUs,
      toCoreAdvantage,
      toJob,
      toContactUs,
      toVideoCenter,
      toMovie,
    };
  },
});
</script>

<style lang="less" scoped>
@import "@/components/styles/footer/AllFooter.less";
</style>
